import React from 'react';
import { Box, Typography, styled } from '@mui/material';

const BannerContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '200px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'white',
    background: 'linear-gradient(135deg, #4CAF50 0%, #2196F3 50%, #9C27B0 100%)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: theme.spacing(2),
    borderBottomLeftRadius: '24px',
    borderBottomRightRadius: '24px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
        height: '250px',
        borderBottomLeftRadius: '16px',
        borderBottomRightRadius: '16px'
    }
}));

const Overlay = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit'
});

const Content = styled(Box)({
    position: 'relative',
    zIndex: 2,
    maxWidth: '800px'
});

const Breadcrumb = styled(Typography)(({ theme }) => ({
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '14px',
    marginBottom: theme.spacing(1),
    '& a': {
        color: 'rgba(255, 255, 255, 0.8)',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));

const Banner = ({ title, description, breadcrumb }) => {
    return (
        <BannerContainer>
            <Overlay />
            <Content>
                {/* {breadcrumb && (
                    <Breadcrumb variant="body2">
                        {breadcrumb}
                    </Breadcrumb>
                )}*/}
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                        marginBottom: 2,
                        color: 'white',
                    }}
                >
                    {title}
                </Typography>
                {description && (
                    <Typography variant="h6" sx={{ fontWeight: 400 }}>
                        {description}
                    </Typography>
                )}
            </Content>
        </BannerContainer>
    );
};

export default Banner;